import { FieldErrors, UseFormRegister } from "react-hook-form";
import { FormTypes } from "../../types/FormTypes";

interface IInputsAdjustmentFactor {
  register: UseFormRegister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  onBlurHandler: (event: any) => void
}

function InputsAdjustmentFactor(props: IInputsAdjustmentFactor) {
  const { errors, register, onBlurHandler } = props;

  return (
    <div>
      <div className="d-flex w-100px">
        <input
          type="number"
          placeholder="0.7"
          step="any"
          className={errors.adjustmentFactor ? "input-error" : ""}
          {...register("adjustmentFactor", {
            required: true,
            min: 0.1,
            max: 1,
            valueAsNumber: true,
            onBlur: onBlurHandler
          })}
        />
      </div>
      <small className="input-small-text">0.1 - 1</small>
    </div>
  );
}

export default InputsAdjustmentFactor;
